module.exports = __webpack_public_path__ + "img/500.45b43d36.png";